import { getInitialValue } from "./getInitialValue";

export default getInitialValue;
